<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="pl-2 py-4"
    elevation="1"
    rounded
  >
    <div class="d-flex align-center">
      <v-text-field
        v-model="search"
        :label="$t('search')"
        class="mr-2"
        clearable
        dense
        hide-details
        outlined
        prepend-inner-icon="mdi-magnify"
        single-line
      />
      <v-btn
        :color="onlyCharged?'primary':'grey'"
        class="mr-2"
        elevation="0"
        outlined
        @click="onlyCharged=!onlyCharged"
      >
        <v-icon left>
          <template v-if="onlyCharged">
            mdi-checkbox-marked
          </template>
          <template v-else>
            mdi-checkbox-blank-outline
          </template>
        </v-icon>
        {{ $t('justLookCharge') }}
      </v-btn>

      <v-btn
        class="mr-2"
        color="primary"
        elevation="0"
        outlined
      >
        {{ $t('totalSales') }}：{{ totalCount }}
      </v-btn>
      <v-btn
        class="mr-2"
        color="warning"
        elevation="0"
        outlined
      >
        {{ $t('totalTurnover') }}：{{ totalPrice |priceDisplay }}
      </v-btn>
      <v-btn
        color="green"
        elevation="0"
        @click="exportExcel"
      >
        {{ $t('excelExport') }}
      </v-btn>
    </div>

    <div
      class="mt-4"
    >
      <template v-for="item in atLeastOne">
        <v-card
          :key="item.currentName+item.amount"
          class="mt-2"
          color="#f0f0f0"
          elevation="0"
        >
          <div class="d-flex align-center pa-2">
            <div>
              {{ item.currentName }}
            </div>
            <v-spacer/>
            <v-chip
              class="mt-1"
              label
            >
              × {{ item.amount }}
            </v-chip>
          </div>
        </v-card>
      </template>
    </div>
  </v-card>
</template>

<script>
  import { Remember } from '@/GlobalSettings'
  import { wordContainsIn } from '@/common/utils'

  export default {
    name: 'ToppingStatistic',

    props: {
      salesData: { type: Array },
    },
    data () {
      return {
        search: '',
        filterItem: {},
        onlyCharged: Remember.onlyCharged,
      }
    },
    computed: {
      atLeastOne () {
        return this.salesData.filter(it => it.amount > 0 &&
          (wordContainsIn(this.search, it.currentName)) &&
          (!this.onlyCharged || it.totalPrice > 0),
        ).map(
          it => {
            return it
          },
        )
      },
      totalPrice () {
        return this.atLeastOne.reduce((sum, i) => sum + parseFloat(i.totalPrice), 0)
      },
      totalCount () {
        return this.atLeastOne.reduce((sum, i) => sum + parseInt(i.amount), 0)
      },
    },
    watch: {
      onlyCharged (val) {
        Remember.onlyCharged = val
      },
    },
    async mounted () {
    },
    methods: {
      exportExcel () {
        const toppingData = this.salesData.filter(it => it.amount > 0 &&
          (wordContainsIn(this.search, it.currentName)),
        ).map(
          it => {
            it.perPrice = it.totalPrice / it.amount
            return it
          },
        )
        const ExportJsonExcel = require('js-export-excel')

        const option = {}

        option.fileName = '配料销售统计'

        option.datas = [
          {
            sheetData: toppingData,
            sheetName: 'sheet',
            sheetHeader: ['总价', '配料名称', '总量', '平均单价'],
            columnWidths: ['', 20, '', ''],
          },
        ]

        const toExcel = new ExportJsonExcel(option) // new
        toExcel.saveExcel() // Save
      },
    },
  }
</script>

<style scoped>
.v-input {
  background: transparent !important;
}

</style>
